import { render, staticRenderFns } from "./payment-setting-form.vue?vue&type=template&id=76975a60"
import script from "./payment-setting-form.vue?vue&type=script&lang=js"
export * from "./payment-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports